export default {
    ssoToken: null,
    idToken: null,
};
